import { render, staticRenderFns } from "./GanttIframe.vue?vue&type=template&id=324d7126&scoped=true&"
import script from "./GanttIframe.vue?vue&type=script&lang=js&"
export * from "./GanttIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d7126",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('324d7126')) {
      api.createRecord('324d7126', component.options)
    } else {
      api.reload('324d7126', component.options)
    }
    module.hot.accept("./GanttIframe.vue?vue&type=template&id=324d7126&scoped=true&", function () {
      api.rerender('324d7126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/export/GanttIframe.vue"
export default component.exports